import { render, staticRenderFns } from "./ServiceOnline.vue?vue&type=template&id=2397bb3d&scoped=true&"
import script from "./ServiceOnline.vue?vue&type=script&lang=js&"
export * from "./ServiceOnline.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOnline.vue?vue&type=style&index=0&id=2397bb3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397bb3d",
  null
  
)

export default component.exports